import { useState, forwardRef } from 'react'
import { NavLink as RouterLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import { colors, Button, Collapse, Hidden, ListItem } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { themeV5 } from 'theme/v5'

const CustomRouterLink = forwardRef((props, ref) => ( // eslint-disable-line
  <div
    ref={ref}
    style={{ flexGrow: 1 }}>
    <RouterLink {...props} />
  </div>
))

const NavigationListItem = ({
  title,
  href,
  depth,
  children,
  icon: Icon,
  className,
  open: openProp,
  label: Label,
  ...rest
}) => {

  const [open, setOpen] = useState(openProp)

  const activeClassStyle = {
    color: themeV5.palette.primary.main,
    fontWeight: themeV5.typography.fontWeightMedium,
    '& $icon': {
      color: themeV5.palette.primary.main
    },
    background: themeV5.palette.background.default,
  }

  const handleToggle = () => {
    setOpen( ! open)
  }

  let paddingLeft = 8

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth
  }

  const style = {
    paddingLeft
  }

  if (children) {
    return (
      <ListItem
        sx={{
          display: 'flex',
          paddingTop: 0,
          paddingBottom: 0,
          ...className
        }}
        {...rest}
        disableGutters>
        <Button
          sx={{
            color: colors.blueGrey[800],
            padding: '10px 8px',
            justifyContent: 'flex-start',
            textTransform: 'none',
            letterSpacing: 0,
            width: '100%'
          }}
          onClick={handleToggle}
          style={style}>
          {Icon && <Icon
            sx={{
              color: themeV5.palette.icons,
              display: 'flex',
              alignItems: 'center',
            }}/>}
          <Hidden mdDown>
            <span
              style={{
                marginLeft: '8px'
              }}>
              {title}
            </span>
          </Hidden>
          {open ? (
            <ExpandLessIcon
              sx={{
                marginLeft: 'auto',
                height: 16,
                width: 16
              }}
              color="inherit" />
          ) : (
            <ExpandMoreIcon
              sx={{
                marginLeft: 'auto',
                height: 16,
                width: 16
              }}
              color="inherit" />
          )}
        </Button>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>
    )
  }

  return (
    <ListItem
      sx={{
        display: 'flex',
        paddingTop: 0,
        paddingBottom: 0,
        ...className
      }}
      {...rest}
      disableGutters>
      <Button
        activeClassName={activeClassStyle}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          padding: '10px 8px',
          width: '100%',
          minWidth: '0',
          color: colors.blueGrey[800],
          textTransform: 'none',
          letterSpacing: 0,
          fontWeight: depth === 0 ? themeV5.typography.fontWeightMedium : themeV5.typography.fontWeightRegular,
          '@media (min-width: 1280px)': {
            justifyContent: 'flex-start',
          },
        }}
        component={CustomRouterLink}
        exact
        style={style}
        to={href}>
        {Icon && <Icon
          sx={{
            color: themeV5.palette.icons,
            display: 'flex',
            alignItems: 'center',
          }}/>}
        <Hidden mdDown>
          <span
            style={{
              marginLeft: '8px'
            }}>
            {title}
          </span>
        </Hidden>
        {Label && (
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: 'auto'
            }}>
            <Label />
          </span>
        )}
      </Button>
    </ListItem>
  )
}

NavigationListItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.any,
  label: PropTypes.any,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired
}

NavigationListItem.defaultProps = {
  depth: 0,
  open: false
}

export default NavigationListItem
